// extracted by mini-css-extract-plugin
export var alphabetWrapper = "glossary-search-module--alphabet-wrapper--iSDF9";
export var nextButton = "glossary-search-module--next-button--1sNWl";
export var previousButton = "glossary-search-module--previous-button--dF5pV";
export var searchWrapper = "glossary-search-module--search-wrapper--jYdsq";